{
  "actions": "Действия",
  "hideButtonLabel": "Показать меньше",
  "noTags": "Нет",
  "showAllButtonLabel": "Показать все ({tagCount, number})"
}
